import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useStore } from "../../../store/store";
import { matchesAgreementSelection } from "../components/ProfessionalCategoryFilter";

export const useStaffWorkLogsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { selectedYear, setSelectedYear, selectedMonth, setSelectedMonth } = useStore((state) => state.staffWorkLogs);

  useEffect(() => {
    const yearParam = searchParams.get("year");
    const monthParam = searchParams.get("month");

    if (yearParam) {
      setSelectedYear(parseInt(yearParam));
    }
    if (monthParam) {
      setSelectedMonth(parseInt(monthParam) - 1); // Subtract 1 since months are 0-based in JS
    }
  }, [searchParams, setSelectedYear, setSelectedMonth]);

  useEffect(() => {
    setSearchParams({
      year: selectedYear.toString(),
      month: (selectedMonth + 1).toString(), // Add 1 to match human-readable months (1-12)
    });
  }, [selectedYear, selectedMonth, setSearchParams]);

  return { selectedYear, setSelectedYear, selectedMonth, setSelectedMonth };
};


const filterEmployeeSummaries = (employeeSummaries: any[], selectedAgreementType: string) => {
  return employeeSummaries.filter((summary) => {
    const monthContractTypes = summary?.monthContractTypes ?? [];
    if (selectedAgreementType === "all") return true;
    if (selectedAgreementType === "services_provider" && monthContractTypes.includes("services_provider")) return true;
    if (selectedAgreementType === "contracts" && monthContractTypes.includes("contract")) return true;
    return false;
  });
};

export const applyEmployeeFilters = (
  employeeSummaries: any[],
  selectedAgreementType: string,
  selectedJob: Array<string>,
) => {
  const agreementFiltered = filterEmployeeSummaries(employeeSummaries, selectedAgreementType);

  if (selectedJob.length === 0) return agreementFiltered;

  return agreementFiltered.filter((summary) =>
    matchesAgreementSelection(
      selectedJob,
      summary?.staffAgreement?.professional_category,
      summary?.user?.technicianSpecializations ?? [],
    )
  );
};
